<template>
  <workshop-management
    :add-participant="apis.workshop.addWorkshopParticipant"
    :application-id="applications.Provider"
    :download-certificate="apis.workshop.downloadWorkshopCertificate"
    :get-all="apis.workshop.getAllWorkshop"
    :get-details="apis.workshop.getWorkshopDetail"
    :get-statuses="apis.workshop.getWorkshopStatuses"
    :last-registered-participant="apis.workshop.getLatestParticipant"
    :redeem="apis.workshop.redeemWorkshop"
    :update-participant-status="apis.workshop.updateParticipantWorkshopStatus"
    :validate-tests="apis.workshop.validateWorkshopTests"
  />
</template>
<script>
import APPLICATION_IDS from '@/utils/constants/applications';
import WorkshopManagement from 'workshop-management';

import * as workshopService from '@/modules/dashboard/dashboardPostMipeApi.js';

export default {
  name: 'OperationsWorkshops',
  components: { WorkshopManagement },
  computed: {
    apis() {
      return Object.freeze({
        workshop: workshopService,
      });
    },
    applications() {
      return { ...APPLICATION_IDS };
    },
  },
};
</script>
